import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import {
    getUsers,
    useGetUsers,
    useGetUsersSuspense,
} from "api/generated/users/users";

function selectUserOverviews(response: Awaited<ReturnType<typeof getUsers>>) {
    if (response.data.type !== "Overview") {
        throw new Error("Expected an overview user list");
    }
    return response.data.data.content.map((dto) => dto.resource);
}

export const useAllUsersSuspenseQuery = () =>
    useGetUsersSuspense(
        { format: "Overview" },
        {
            query: {
                select: selectUserOverviews,
                staleTime: STALE_TIME_RESOURCES,
            },
        }
    );

export const useAllUsersQuery = ({ enabled }: { enabled: boolean }) =>
    useGetUsers(
        { format: "Overview" },
        {
            query: {
                enabled,
                select: selectUserOverviews,
                staleTime: STALE_TIME_RESOURCES,
            },
        }
    );
